import React from "react";
import banner from "../../assets/projects/knowledge_flow_banner.jpg";
import ss1 from "../../assets/screenshots/knowledgeflow/upload-document-workflow.png";
import ss2 from "../../assets/screenshots/knowledgeflow/ask-ai.png";
import ss3 from "../../assets/screenshots/knowledgeflow/manage-knowledge.png";
import ss4 from "../../assets/screenshots/knowledgeflow/create-knowledge.png";

const KnowledgeFlowPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">
    {/* Banner Image */}
    <section className="w-full">
      <img
        src={banner}
        alt="KnowledgeFlow Banner"
        className="w-[500px] rounded-xl shadow-md object-cover"
      />
    </section>

    {/* Project Title & Overview */}
    <section>
      <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
        KnowledgeFlow
      </h1>
      <p className="text-lg text-content lg:max-w-4xl">
        KnowledgeFlow is an AI-powered document management and Q&A system that allows admins to create and manage knowledge documents stored in a vector database, and allows users to ask natural language questions based on that knowledge. Built using Bubble.io, n8n, Supabase Vector Store, and powered by ChatGPT and Gemini, this platform supports intelligent document understanding, upload, update, deletion, and retrieval workflows.
      </p>
    </section>

    {/* Technology Stack */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        💻 Technology Stack
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>n8n:</strong> Handles all AI automation workflows like upload, update, delete, and Q&A</li>
        <li><strong>Supabase Vector Store:</strong> Stores document embeddings for AI-powered semantic search</li>
        <li><strong>Bubble.io:</strong> Frontend web interface for users and admins</li>
        <li><strong>ChatGPT:</strong> Used to answer user questions based on vector search results</li>
        <li><strong>Gemini:</strong> Adds document understanding context for more accurate AI interpretation</li>
        <li><strong>JavaScript:</strong> Used for custom client-side logic</li>
      </ul>
    </section>

    {/* n8n Workflows */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🔄 n8n Automation Workflows
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>Upload to Document Vector Store:</strong> Admins can upload new PDF documents to be embedded into the vector store</li>
        <li><strong>Update/Replace Document:</strong> Allows replacing existing documents with updated versions</li>
        <li><strong>Ask Questions:</strong> Processes user queries, performs vector search, and returns AI-generated answers</li>
        <li><strong>Delete Document:</strong> Removes a document and its vector embeddings from the database</li>
      </ul>
    </section>

    {/* Bubble.io Features */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🧑‍💻 Web App (Bubble.io)
      </h2>

      <h3 className="text-2xl font-semibold mt-6 mb-2">🔹 Main Features</h3>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Ask questions based on documents in Supabase Vector Store</li>
        <li>Upload documents to create knowledge</li>
        <li>Update/replace existing documents</li>
        <li>Delete documents from the vector store</li>
        <li>Download or view PDF files</li>
      </ul>
    </section>

    {/* Screenshots */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🖼️ Project Images & Screenshots
      </h2>
      <div className="flex flex-col gap-6">
      <div>
          <p className="mb-2 font-medium">Document Upload Workflow (n8n)</p>
          <a href={ss1} target="_blank" rel="noopener noreferrer">
            <img src={ss1} alt="Update Interface" className="w-full rounded-lg shadow" />
          </a>
        </div>
        <div>
          <p className="mb-2 font-medium">Ask AI (Ask Questions / Get Information from the Knowledge Database)</p>
          <a href={ss2} target="_blank" rel="noopener noreferrer">
            <img src={ss2} alt="Ask AI Interface" className="w-full rounded-lg shadow" />
          </a>
        </div>
        
        <div>
          <p className="mb-2 font-medium">Knowledge Management Page (Admin)</p>
          <a href={ss3} target="_blank" rel="noopener noreferrer">
            <img src={ss3} alt="Admin View" className="w-full rounded-lg shadow" />
          </a>
        </div>

        <div>
          <p className="mb-2 font-medium"> Knowledge Creation Page (Admin)</p>
          <a href={ss4} target="_blank" rel="noopener noreferrer">
            <img src={ss4} alt="Upload Interface" className="w-full rounded-lg shadow" />
          </a>
        </div>
     
    
     
     
      </div>
    </section>
  </main>
);

export default KnowledgeFlowPage;
